export default {
  methods: {
    focusOnFirstError() {
      this.$nextTick(() => {
        const containerEl = this.$el.querySelector('.el-form-item.is-error');
        if (!containerEl) {
          return;
        }

        containerEl.scrollIntoView(true);

        const scrolledY = window.scrollY;
        if (scrolledY) {
          window.scroll(0, scrolledY - 40);
        }

        const inputEls = containerEl.querySelectorAll('.el-input__inner, .el-radio__original, .el-checkbox__original');
        if (inputEls.length) {
          inputEls[0].focus();
        }
      });
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!('form' in this.$refs)) {
          return resolve();
        }

        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.focusOnFirstError();
            return reject();
          }

          return resolve();
        });

        return true;
      });
    },
  },

  created() {
    this.hasValidation = true;
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validation.js